<div class="si-multiline {{styleClass}}" [class.disabled]="disabled"
     [class.invalid]="formModel.invalid && (formModel.dirty || formModel.formDirective?.submitted || validationExternalErrorText)">
  <div class="si-multiline_container">
    <div *ngIf="!hideLabel">
      <si-label [text]="text"
                [tooltipText]="tooltipText"
                [tooltipPosition]="tooltipPosition"
                [tooltipIcon]="tooltipIcon"
                [tooltipStyleClass]="tooltipStyleClass"
                [tooltipEscape]="tooltipEscape"
                [forceShowTooltipIcon]="forceShowTooltipIcon"
                (tooltipIconClick)="onClickTooltipIcon($event)"
                forId="si-multiline_editor-{{id}}"
      ></si-label>
    </div>
  </div>
  <div class="si-multiline_textarea" siProvideParentForm>
    <textarea #formModel="ngModel"
              id="si-multiline_editor-{{id}}"
              name="{{name}}"
              placeholder="{{disabled ? '' : (placeholder | translate)}}"
              [disabled]="disabled"
              [ngModel]="model"
              [ngModelOptions]="{updateOn: updateNgModelOnBlur ? 'blur' : 'change'}"
              (ngModelChange)="onChangeModel($event)"
              rows="{{rows}}"
              (blur)="onBlur($event)"
              siValidation="{{rule}}"
              [siValidationElement]="validationElement"
              [siValidationExternalErrorText]="validationExternalErrorText">
    ></textarea>
  </div>
  <si-validation-element #validationElement
                         [formModel]="formModel"
                         [showErrorText]="!showRuleErrorOutsideIcon"
                         (errorTextChange)="validationErrorText = $event"
                         class="si-multiline_validation"
  ></si-validation-element>
  <div *ngIf="showRuleErrorOutsideIcon">
    <si-validation-error-text [text]="validationErrorText || validationExternalErrorText"
                              [formModel]="formModel"
    ></si-validation-error-text>
  </div>
</div>
